import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './routes/App';



document.body.className = 'bodyFull'
ReactDOM.render(<App />, document.getElementById('App'));
